import React from 'react';
import img1 from '../../../../Brand/kavan.jpg';
import img2 from '../../../../Brand/Gazi-Group-DTIF-2.png';
import './Brand.css';
import { Link } from 'react-router-dom/dist';

const Brand = () => {
    return (
        <section className='brand-section'>
            <div className='brand-head'>
            </div>
            <div className='flex justify-center my-12'>
                <Link to='/kavan'>
                    <div className='m-4 text-center'>
                        <img src={img1} alt="" className='w-96 h-40 lg:h-96' />
                        <h1 className='kavan-h1'>Kavan Relocation</h1>
                    </div>
                </Link>
                <Link to='/gazi'>
                    <div className='m-4 text-center'>
                        <img src={img2} alt="" className='w-96' />
                        <h1 className='kavan-h1'>Gazi Group DITF</h1>
                    </div>
                </Link>
            </div>
        </section>
    );
};

export default Brand;